import { render, staticRenderFns } from "./PunkDetail.vue?vue&type=template&id=1841810e"
import script from "./PunkDetail.vue?vue&type=script&lang=js"
export * from "./PunkDetail.vue?vue&type=script&lang=js"
import style0 from "./PunkDetail.vue?vue&type=style&index=0&id=1841810e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports